<template>
  <pt-all-audit-table class="pt-all-audit-table__withData" @getTableData="getTableData" :tableData="tableData" :totalNumber="totalNumber"
  :pageSize="pageSize" ref="table" :hasMedicalReward="hasMedicalReward" :departmentBalance="departmentBalance" :businessDepartmentId='paramsData.businessDepartmentId' :departmentList="departmentList">
  </pt-all-audit-table>
</template>

<script>
import PtAllAuditTable from './index'
import { cashCount } from '@/utils/formUtils'
export default {
  name: 'pt-all-audit-table__withData',
  components: {
    'pt-all-audit-table': PtAllAuditTable
  },
  props: {
    paramsData: {
      type: Object
    },
    isFromRouter: {
      type: Boolean
    },
    departmentList: Array,
    hasMedicalReward: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      pageSize: 10,
      totalNumber: null,
      tableData: [],
      departmentBalance: null,
      balanceLoading: false
    }
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  watch: {
    paramsData: {
      handler: function (val, old) {
        if (!this.isFromRouter) {
        //   this.getOrderList(0)
          this.$refs.table.resetPage()
        } else {
          this.isOutside = true
          this.getTableData(this.page)
        }
      },
      deep: true
    },
    'paramsData.businessDepartmentId': {
      handler: function (val) {
        this.getDepartmentBalance()
      }
    }

  },
  methods: {
    getDepartmentBalance () {
      let api = this.paramsData.businessDepartmentId ? 'getDepartmentBalance' : 'getAllDepartmentBalance'
      this.balanceLoading = true
      this.$store.dispatch(api, this.paramsData.businessDepartmentId).then(res => {
        this.balanceLoading = false
        this.departmentBalance = this.paramsData.businessDepartmentId ? (res.data.quota && cashCount(res.data.quota, true, 2)) : (res && cashCount(res, true, 2))
      }).catch(err => {
        this.balanceLoading = false
        this.$message.error(err || '获取业务部额度失败')
      })
    },
    getTableData (page, next, size) {
      let data = {
        ...this.paramsData,
        pageable: {
          page: this.page,
          size: size || this.pageSize,
          sort: 'createdDate,desc'
        }
      }
      let api = this.hasMedicalReward ? 'getMedicalRewardList' : 'getAllAuditList'
      this.$store.dispatch(api, data).then(res => {
        if (next) {
          next(res.data)
        }
        this.totalNumber = res.totalNumber
        this.tableData = res.data
      }).catch(err => {
        this.$message.error(err || '获取奖励汇总列表失败')
      })
    }
  },
  created () {
    if (!this.hasMedicalReward) {
      this.getDepartmentBalance()
    }
  }
}
</script>
